import React from 'react';
import { motion } from 'framer-motion';
import { Briefcase, GraduationCap, Building2, Globe2, Rocket } from 'lucide-react';
export function AudienceSection() {
  const audiences = [{
    icon: <Briefcase size={28} data-id="element-14" />,
    title: 'Consultants',
    desc: 'Scale expertise into systems'
  }, {
    icon: <GraduationCap size={28} data-id="element-15" />,
    title: 'Academics',
    desc: 'Turn research into living knowledge'
  }, {
    icon: <Building2 size={28} data-id="element-16" />,
    title: 'Organizations',
    desc: 'Train dynamically and adapt continuously'
  }, {
    icon: <Globe2 size={28} data-id="element-17" />,
    title: 'Communities',
    desc: 'Connect people through meaningful conversations'
  }, {
    icon: <Rocket size={28} data-id="element-18" />,
    title: 'Innovators',
    desc: 'Move from idea to action faster'
  }];
  return <section className="py-24 bg-gray-900 text-white" data-id="element-19">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-20">
        <div className="text-center mb-16" data-id="element-21">
          <h2 className="text-amber-500 font-semibold tracking-wide uppercase text-sm mb-3" data-id="element-22">
            Who It's For
          </h2>
          <h3 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-23">
            Empowering Every Knowledge Worker
          </h3>
          <p className="text-gray-400 max-w-2xl mx-auto" data-id="element-24">
            Latteware provides the infrastructure for anyone looking to
            transform static information into dynamic, actionable systems.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 lg:grid-cols-5 gap-6" data-id="element-25">
          {audiences.map((aud, idx) => <motion.div key={idx} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.5,
          delay: idx * 0.1
        }} className="bg-gray-800 p-6 rounded-xl border border-gray-700 hover:border-amber-500 transition-colors flex flex-col items-center text-center" data-id="element-26">
              <div className="w-14 h-14 bg-gray-900 rounded-full flex items-center justify-center text-amber-500 mb-4" data-id="element-27">
                {aud.icon}
              </div>
              <h4 className="font-bold text-lg mb-2" data-id="element-28">{aud.title}</h4>
              <p className="text-sm text-gray-400" data-id="element-29">{aud.desc}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}